module.exports = __webpack_public_path__ + "static/img/lichengImg2.48e44b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/lichengImg2.png
// module id = xsP+
// module chunks = 2